const appName = process.env.GATSBY_APP_NAME;

const hasDoc = typeof document !== "undefined";

const cookieToObj = () => {
  if (hasDoc) {
    return document.cookie.split(";").reduce((a, b) => {
      const [k, v] = b.split("=");
      return { ...a, [k]: decodeURI(v) };
    }, {});
  }
  return {};
};

export const getCookie = k => {
  return cookieToObj()[`${appName}_${k}`] || cookieToObj()[k];
};

export const setCookie = (k, v = true, e = 365) => {
  if (hasDoc) {
    const date = new Date();
    date.setTime(date.getTime() + e * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${appName}_${k}=${v}; ${expires}; path=/`;
  }
};

export const hasCookie = (k, v, e = 365, reset = false) => {
  if (hasDoc) {
    // console.log(cookieToObj()[`${appName}_${k}`], v);
    if (cookieToObj()[`${appName}_${k}`] === v) {
      if (reset) {
        setCookie(k, v, e);
      }
      return true;
    }
  }
  return false;
};

export default { hasCookie, setCookie, getCookie };
